// apicore
import {APICore} from "../../helpers/api/apiCore";

// constants
import {AuthActionTypes} from "./constants";

const api = new APICore();

const INIT_STATE = {
    user: api.getLoggedInUser(),
    loading: false,
};

interface UserData {
    id: number;
    email: string;
    password?: string;
    name: string;
    surname: string;
    roles: string[];
    permission: string[];
    access_token: string;
    expiresIn?: number;
    refresh_token: string;
}

interface AuthActionType {
    type:
        | AuthActionTypes.API_RESPONSE_SUCCESS
        | AuthActionTypes.API_RESPONSE_ERROR
        | AuthActionTypes.LOGIN_USER
        | AuthActionTypes.LOGOUT_USER
        | AuthActionTypes.PERMISSIONS_REFRESHED
        | AuthActionTypes.RESET;
    payload: {
        actionType?: string;
        data?: UserData | {};
        error?: string;
    };
}

interface State {
    user?: UserData | {};
    loading?: boolean;
    value?: boolean;
}

const Auth = (state: State = INIT_STATE, action: AuthActionType): any => {
    switch (action.type) {
        case AuthActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        user: action.payload.data,
                        userLoggedIn: true,
                        loading: false,
                    };
                }
                case AuthActionTypes.LOGOUT_USER: {
                    return {
                        ...state,
                        user: null,
                        loading: false,
                        userLogout: true,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        resetPasswordSuccess: action.payload.data,
                        loading: false,
                        passwordReset: true,
                    };
                }
                default:
                    return {...state};
            }

        case AuthActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case AuthActionTypes.LOGIN_USER: {
                    return {
                        ...state,
                        error: action.payload.error,
                        userLoggedIn: false,
                        loading: false,
                    };
                }
                case AuthActionTypes.FORGOT_PASSWORD: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        passwordReset: false,
                    };
                }
                default:
                    return {...state};
            }

        // A fresh permission list from the server. Replaces `permission` on the user in
        // place — a NEW array reference, which is what helpers/can.ts keys its rebuild on
        // and what makes the subscribed components re-render.
        case AuthActionTypes.PERMISSIONS_REFRESHED: {
            const permission = (action.payload as any)?.permission;
            if (!state.user || !Array.isArray(permission)) return state;
            return {...state, user: {...(state.user as object), permission}};
        }

        case AuthActionTypes.LOGIN_USER:
            return {...state, loading: true, userLoggedIn: false};
        case AuthActionTypes.LOGOUT_USER:
            return {...state, loading: true, userLogout: false};
        case AuthActionTypes.RESET:
            const api = new APICore();
            api.setLoggedInUser(null);
            return {
                ...state,
                loading: false,
                error: false,
                userSignUp: false,
                userLoggedIn: false,
                passwordReset: false,
                passwordChange: false,
                resetPasswordSuccess: null,
            };
        default:
            return {...state};
    }
};

export default Auth;
